import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('browse');
export default logger;
